<template>
    <VJoyWrapper class="no-invoices__wrapper" direction="column" row-gap="1">
        <MaltIllustration name="invoices--high" alt="" width="130" />
        <h2>{{ t('projectclient.projectview.invoices.empty.state.title') }}</h2>
        <p>{{ t('projectclient.projectview.invoices.empty.state.description') }}</p>
    </VJoyWrapper>
</template>

<script setup lang="ts">
    import {MaltIllustration} from '#components';
    import {useTranslation} from '#imports';
    import {VJoyWrapper} from '@maltjoy/core-vue';

    const {t} = useTranslation();
</script>

<style lang="scss" scoped>
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/text';

    .no-invoices {
        &__wrapper {
            flex: 1;
            width: 500px;
            margin-top: var(--joy-core-spacing-10);
            text-align: center;

            & > h2 {
                color: var(--joy-color-neutral-60);
                margin: var(--joy-core-spacing-6) 0 var(--joy-core-spacing-1) 0;

                @include text.getFontBySize(primary-650);
            }
        }
    }
</style>
